import { render, staticRenderFns } from "./CreateIndividual.vue?vue&type=template&id=7c85aa6e&scoped=true"
import script from "./CreateIndividual.vue?vue&type=script&lang=js"
export * from "./CreateIndividual.vue?vue&type=script&lang=js"
import style0 from "./CreateIndividual.vue?vue&type=style&index=0&id=7c85aa6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c85aa6e",
  null
  
)

export default component.exports